import { render } from "./Save_instruction.vue?vue&type=template&id=2fcfbbb1"
import script from "./Save_instruction.vue?vue&type=script&lang=js"
export * from "./Save_instruction.vue?vue&type=script&lang=js"

import "./Save_instruction.vue?vue&type=style&index=0&id=2fcfbbb1&lang=css"

import exportComponent from "/Users/romanmatveev/Documents/Dev/html_docs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__